module.exports = __webpack_public_path__ + "img/shaping-the-future-of-education.29537356.jpg";